export class CustomerModel {
    public Id
    public Company: string;
    public Name: string;
    public Address1: string;
    public Address2: string;
    public City: string;
    public ZipCode: string;
    public State: string;
    public Email: string;
    public MobileNumber: string;
    public CreatedDate: string;
    public LastModifiedDate: string;
    public CreatedBy: string;
    public LastModifiedBy: string;
    public IsDeleted: boolean;
    public AccountId: number;
    public LoanCounter: number;
}



// WEBPACK FOOTER //
// ./src/app/models/CustomerModel.ts